<template>
  <div>
    <Card>
      <h2>订单详情</h2>
      <br>
      <span class>订单号: {{this.order.code}}</span>
      <br><br>
      <span class>下单时间: {{this.order.created_at_str}}</span>
      <br><br>
      <span class>下单平台: {{this.order.come_from === 'wechat_mini' ? '小程序' : '前台'}}</span>
      <br><br>
      <span class>订单状态: {{this.paymentChinese(this.order.status)}}</span>
      <br><br>
      <span class>收货方式: <tag :color="delivery.color">{{ delivery.text }}</tag></span>
      <br><br>
      <span class v-if="order.delivery === 'merchant_send'">
        收货地址: {{ order.fresh_address_province }} {{ order.fresh_address_city }} {{ order.fresh_address_district }} {{ order.fresh_address_content }}
      </span>
      <!-- <Form ref:form-inline inline>
        <Form-item>
          <Button v-if="this.order.status === 'paid'" type="info" @click="deliver">发货</Button>
        </Form-item>
      </Form> -->
      <Table
        style="margin-top: 20px;"
        border
        :loading="loading"
        :columns="columns"
        :data="order.fresh_order_items"
      >
        <template slot="fresh_product_name" slot-scope="{ row }">
          <div class="product-name">
            <img :src="row.fresh_product_images[0]" height="50px" /> {{ row.fresh_product_name }}
          </div>
        </template>
        <template slot="specs" slot-scope="{ row }">
          {{ renderSpecs(row) }}
        </template>
        <template slot="total" slot-scope="{ row }">
          {{ (row.huiyuanjia || 0) * row.quantity }}
        </template>
      </Table>
    </Card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { booleanChinese } from '@/libs/table-render'

export default {
  data () {
    return {
      id: this.$route.params.id,
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: '商品名称',
          key: 'current_product_name',
          width: 200,
          align: 'center'
        },
        {
          title: '购买价格',
          key: 'current_price',
          width: 120,
          align: 'center'
        },
        {
          title: '数量',
          key: 'quantity',
          width: 100,
          align: 'center'
        },
        {
          title: '总价',
          key: 'total',
          width: 100,
          align: 'center'
        },
        {
          title: '规格',
          key: 'fresh_product_unit',
          width: 100,
          align: 'center'
        },
        {
          title: '是否称重',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.fresh_product_need_to_weight)
          }
        }
      ]
    }
  },
  created () {
    this.show(this.id)
  },
  computed: {
    ...mapGetters('order', ['order', 'meta', 'loading']),
    delivery () {
      return {
        merchant_send: {
          color: 'blue',
          text: '商家自配送'
        },
        user_fetch: {
          color: 'cyan',
          text: '用户自提'
        }
      }[this.order.delivery] || { color: 'blue', text: '商家自配送' }
    }
  },
  methods: {
    ...mapActions('order', ['show', 'deliver_order']),
    ...mapMutations('order', ['changeQuery', 'resetQuery']),
    deliver () {
      this.$Modal.confirm({
        title: '操作提醒',
        content: '确定修改订单状态为已发货吗？',
        onOk: () => {
          this.deliver_order(this.id)
        }
      })
    },
    paymentChinese (payment_method) {
      if (payment_method === 'unpaid') {
        return '待支付'
      } else if (payment_method === 'refund') {
        return '已退款'
      } else if (payment_method === 'pending') {
        return '挂单中'
      } else if (payment_method === 'paid') {
        return '已支付'
      } else if (payment_method === 'unreceived') {
        return '待收货'
      } else if (payment_method === 'unreviewed') {
        return '待评价'
      } else if (payment_method === 'finished') {
        return '完成'
      }
    },
    renderSpecs (row) {
      const specs = (row.mall_sku && row.mall_sku.mall_properties) || []
      return specs.map(item => {
        return item.mall_property_name_name + ':' + item.mall_property_value_name
      }).join('/') || '-'
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
.filter-container {
  padding-bottom: 10px;
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
}
</style>
